import React, { useState } from 'react'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'
import { useSelector } from 'react-redux'

import { leaveTypeSelector, teamCalendarSelector } from '../../../selectors'

import ModalLeaveDetial from '../../../components/modal-leave-detail'
import ModalCompensateDetail from '../../../components/leave-request/compensate/modal-compensate-detail'

import moment from '../../../lib/moment.js'

export const Cell = ({ date, row, publicHolidays }) => {
  const [flag, setFlag] = useState(0)
  const [modalData, setModalData] = useState({})
  const [showLeave, setShowLeave] = useState(false)
  const [showCompensate, setShowCompensate] = useState(false)

  const leaveTypes = useSelector(leaveTypeSelector.getLeaveTypeData)
  const allRequests = useSelector(teamCalendarSelector.getTeamCalendar)
  const projects = allRequests ? allRequests.projectInfor : []
  const users = allRequests ? allRequests.users : []

  const isWeekEnd = date.day() === 0 || date.day() === 6
  const data = row.map[moment(date).format('YYYY-MM-DD')]

  const isPublicHoliday = () => {
    let holiday = { holiday: null, isHoliday: false }
    if (publicHolidays) {
      const _holiday = publicHolidays.find(h => {
        return moment(date).isSame(moment(h.date), 'day')
      })
      if (_holiday) holiday = { holiday: _holiday, isHoliday: true }
    }
    return holiday
  }

  const clickCell = (flag) => {
    if (flag) {
      handleClickCell(flag, holiday.holiday)
    } else {
      handleClickCell(flag, data)
    }
  }

  const handleLeaveDetail = () => {
    setShowLeave(!showLeave)
  }

  const handleCompensateDetail = () => {
    setShowCompensate(!showCompensate)
  }

  const handleClickCell = (isHoliday, cell) => {
    if (isHoliday) {
      setShowLeave(!showLeave)
      setFlag(1)
      setModalData({ holiday_name: cell.description })
    } else if (cell.events.length > 1) {
      const events = [...cell.events]
      const approver = users.find(u => u._id === events[0].approver_id)
      events[0].approver = approver ? `${approver.first_name} ${approver.last_name}` : ''
      const approver2 = users.find(u => u._id === events[1].approver_id)
      events[1].approver = approver2 ? `${approver2.first_name} ${approver2.last_name}` : ''
      if (events[0].leave_type_id) {
        const type = leaveTypes.find(t => t._id === events[0].leave_type_id)
        events[0].leave_type = type ? type.name : ''
        const type2 = leaveTypes.find(t => t._id === events[1].leave_type_id)
        events[1].leave_type = type2 ? type2.name : ''
        setModalData({ events: orderBy(events, ['leave_time'], 'asc') })
        setShowLeave(!showLeave)
      } else {
        const project = projects.find(p => p._id === cell.events[0].project_id)
        events[0].project = project ? `${project.project_code} - ${project.name}` : '-'
        const project2 = projects.find(p => p._id === cell.events[0].project_id)
        events[1].project = project2 ? `${project2.project_code} - ${project2.name}` : '-'
        setModalData({ events: orderBy(events, ['compensate_time'], 'asc') })
        setShowCompensate(!showCompensate)
      }
    } else {
      const events = cell.events
      const approver = users.find(u => u._id === events[0].approver_id)
      events[0].approver = approver ? `${approver.first_name} ${approver.last_name}` : ''
      if (!cell.events[0].leave_type_id) {
        setShowCompensate(!showCompensate)
        const project = projects.find(p => p._id === cell.events[0].project_id)
        events[0].project = project ? `${project.project_code} - ${project.name}` : '-'
        setFlag(0)
        setModalData({ events })
      } else {
        setShowLeave(!showLeave)
        const type = leaveTypes.find(t => t._id === events[0].leave_type_id)
        events[0].leave_type = type ? type.name : ''
        setFlag(0)
        setModalData({ events })
      }
    }
  }

  const holiday = isPublicHoliday()
  const isHoliday = holiday.isHoliday

  return (
    <Root
      onClick={ data ? () => clickCell(false) : (isHoliday ? () => clickCell(true) : () => {}) }
      style={ {
        cursor: data || isHoliday ? 'pointer' : '',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        overflow: 'hidden',
        backgroundColor: isHoliday ? '#7B7B7B' : isWeekEnd ? '#DDDDDD' : 'white',
      } }
    >
      { showLeave && (
        <ModalLeaveDetial
          { ...modalData }
          showDetail={ showLeave }
          flag={ flag }
          handleLeaveDetail={ handleLeaveDetail }
        />
      )}
      { showCompensate && (
        <ModalCompensateDetail
          { ...modalData }
          showCompensate={ showCompensate }
          flag={ flag }
          handleCompensateDetail={ handleCompensateDetail }
        />
      )}
      { data && data.events.length === 2 && orderBy(data.events, ['leave_time'], 'asc').map(event => event.content)}
      { data && data.events.length === 1 && data.events[0].content}
    </Root>
  )
}

const Root = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/cell.js